/** Empty-state copy for the Today panel (no CTA — AddTaskRow sits below the list). */
import { Typography } from '@mui/material';
import {
  TodayPanelEmptyVariant,
  resolveTodayPanelEmptyVariant,
} from '@/features/today/utils/todayPanelEmptyMessage';

const TodayPanelEmptyMessage = ({
  t,
  allTasksCount,
  completedTodayCount,
}) => {
  const variant = resolveTodayPanelEmptyVariant({
    allTasksCount,
    completedTodayCount,
  });

  if (variant === TodayPanelEmptyVariant.NEVER_HAD_TASKS) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('todayviewcontent.todayNoTasksEver', 'Begin met één taak.')}
      </Typography>
    );
  }

  const textKey =
    variant === TodayPanelEmptyVariant.NOTHING_PLANNED
      ? 'todayviewcontent.todayNothingPlanned'
      : 'todayviewcontent.todayEmpty';
  const fallback =
    variant === TodayPanelEmptyVariant.NOTHING_PLANNED
      ? 'Niets gepland voor vandaag.'
      : 'No open tasks for today! 🎉';

  return (
    <Typography variant="body2" color="text.secondary" data-testid="today-empty-message">
      {t(textKey, fallback)}
    </Typography>
  );
};

export default TodayPanelEmptyMessage;
